/* eslint-disable react/prop-types */
import React from 'react';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { useTranslation } from 'react-i18next';
// TODO: remove when backend will be ready
import { categories, countries, currencies, driver_categories, education_level, industries, lang_skills, langs } from '../../../settings';

const DesktopAdvancedSearch = ({
  errors,
  searchAgeTo,
  searchParams,
  handleKeyDown,
  searchAgeFrom,
  subCategories,
  searchSalaryTo,
  searchSalaryFrom,
  handleResetFilters,
  handleAddSearchItem,
  searchSalaryCurrency,
  sortValueRadioSettings,
  getSubCategoriesOptions,
  // handleChangeSearchPlace,
  handleRemoveSearchParam,
  handleChangeAgeAndSalary,
  searchLogicRadioSettings,
  debouncedGetCitiesOptions,
  resultsPeriodRadioSettings,
  // searchPlaceCheckboxSettings,
  searchGenderCheckboxSettings,
  searchLocationCheckboxSettings,
  searchWorkTypeCheckboxSettings,
  handleChangeSearchDriverLicense,
  handleChangeSortValueSearchLogic,
  searchExperienceCheckboxSettings,
  handleChangeExperienceWorkTypeGender,
  handleChangeRegionsCategoriesLanguages,
  handleChangeIndustryEducationDriverCategories,
}) => {
  const { t } = useTranslation('global');

  const {
    sortValue = '',
    searchLogic = '',
    // searchPlace = [],
    searchGender = [],
    resultsPeriod = '',
    searchRegions = [],
    searchLocation = [],
    searchIndustry = [],
    searchWorkType = [],
    searchEducation = [],
    searchLanguages = [],
    searchCategories = [],
    searchExperience = [],
    searchDriverCategories = [],
    searchDriverLicense = false,
  } = searchParams;

  return (
    <section className='advancedSearchSection col-lg-3'>
      <h2>
        {t('JobseekerSearchList.sortBy')}
      </h2>
      <div className='paramsBox'>
        <div className='searchLogicBox'>
          {
            sortValueRadioSettings.map(i => (
              <label key={i.value} className={`radioLabel ${sortValue === i.value && 'selected'}`}>
                <input
                  type='radio'
                  value={i.value}
                  checked={sortValue === i.value}
                  onChange={e => handleChangeSortValueSearchLogic(e, 'sortValue')}
                />
                {t(`JobseekerSearchList.${i.text}`)}
              </label>
            ))
          }
        </div>
      </div>
      <h2>
        {t('JobseekerSearchList.resultsPeriod')}
      </h2>
      <div className='paramsBox'>
        <div className='searchLogicBox'>
          {
            resultsPeriodRadioSettings.map(i => (
              <label key={i.value} className={`radioLabel ${resultsPeriod === i.value && 'selected'}`}>
                <input
                  type='radio'
                  value={i.value}
                  checked={resultsPeriod === i.value}
                  onChange={e => handleChangeSortValueSearchLogic(e, 'resultsPeriod')}
                />
                {t(`JobseekerSearchList.${i.text}`)}
              </label>
            ))
          }
        </div>
      </div>
      <h2>
        {t('jobseekerListing.advancedSearch')}
      </h2>
      <div className='paramsBox'>
        <p>
          {t('jobseekerListing.searchLogic')}
        </p>
        <div className='searchLogicBox'>
          {
            searchLogicRadioSettings.map(i => (
              <label key={i.value} className={`radioLabel ${searchLogic === i.value && 'selected'}`}>
                <input
                  type='radio'
                  value={i.value}
                  checked={searchLogic === i.value}
                  onChange={e => handleChangeSortValueSearchLogic(e, 'searchLogic')}
                />
                {t(`jobseekerListing.${i.text}`)}
              </label>
            ))
          }
        </div>
      </div>
      {/* <div className='paramsBox'>
        <p>
          {t('jobseekerListing.searchPlace')}
        </p>
        <div className='searchPlaceBox'>
          {
            searchPlaceCheckboxSettings.map(i => (
              <label key={i.name} className='checkboxLabel'>
                <input
                  name={i.name}
                  type='checkbox'
                  onChange={handleChangeSearchPlace}
                  checked={searchPlace.includes(i.name)}
                />
                {t(`jobseekerListing.${i.text}`)}
              </label>
            ))
          }
        </div>
      </div> */}
      <h2>
        {t('jobseekerListing.region')}
      </h2>
      <div className='paramsBox'>
        <p>
          {t('jobseekerListing.moving')}
        </p>
        <div className='searchWorkTypeBox'>
          {
            searchLocationCheckboxSettings.map(i => (
              <label key={i.name} className='checkboxLabel' title={!searchRegions[0]?.country && t('jobseekerListing.selectCountryFirst')}>
                <input
                  name={i.name}
                  type='checkbox'
                  disabled={!searchRegions[0]?.country}
                  checked={searchLocation.includes(i.name)}
                  onChange={e => handleChangeExperienceWorkTypeGender(e, 'searchLocation')}
                />
                {t(`jobseekerListing.${i.text}`)}
              </label>
            ))
          }
        </div>
      </div>
      {
        searchRegions?.map((i, index) => (
          <div key={index} className='paramsBox'>
            <p>
              {t('jobseekerListing.country')}
            </p>
            <div className='regionParamsBox'>
              <Select
                isClearable
                value={i.country}
                name={`country_${index}`}
                placeholder={t('jobseekerListing.selectCountry')}
                noOptionsMessage={() => t('jobseekerListing.noOptionsFound')}
                options={countries.map(i => ({ value: i.id, label: i.name }))}
                onChange={selectedOption => handleChangeRegionsCategoriesLanguages('searchRegions', 'country', selectedOption, index)}
              />
            </div>
            {
              i.country && (
                <div>
                  <p>
                    {t('jobseekerListing.city')}
                  </p>
                  <div className='regionParamsBox'>
                    <AsyncSelect
                      isMulti
                      value={i.cities}
                      name={`cities_${index}`}
                      placeholder={t('jobseekerListing.enterCityName')}
                      loadingMessage={() => t('jobseekerListing.pleaseWait')}
                      options={countries.map(i => ({ value: i.id, label: i.name }))}
                      loadOptions={inputValue => debouncedGetCitiesOptions(inputValue, index)}
                      onChange={selectedOptions => handleChangeRegionsCategoriesLanguages('searchRegions', 'cities', selectedOptions, index, 5)}
                      noOptionsMessage={
                        ({ inputValue }) => inputValue.length >= 2
                          ? t('jobseekerListing.noOptionsFound')
                          : t('jobseekerListing.enterCityName')
                      }
                      styles={{
                        multiValue: baseStyles => ({
                          ...baseStyles,
                          width: '100%',
                          justifyContent: 'space-between',
                        }),
                      }}
                    />
                    {
                      errors.searchRegions[index]?.cities && (
                        <div className='text-danger'>{errors.searchRegions[index]?.cities}</div>
                      )
                    }
                  </div>
                </div>
              )
            }
            <div className='advancedSearchButtons'>
              <button
                type='button'
                onClick={() => handleAddSearchItem('searchRegions')}
                disabled={i.country === null || searchRegions?.length > 2}
              >
                <i className='fa-solid fa-plus' />
                {t('jobseekerListing.addRegion')}
              </button>
              {
                searchRegions?.length > 1 && (
                  <button
                    type='button'
                    onClick={() => handleRemoveSearchParam('searchRegions', index)}
                  >
                    <i className='fa-solid fa-trash' />
                    {t('jobseekerListing.remove')}
                  </button>
                )
              }
            </div>
          </div>
        ))
      }
      <h2>
        {t('jobseekerListing.categories')}
      </h2>
      {
        searchCategories?.map((i, index) => (
          <div key={index} className='paramsBox'>
            <p>
              {t('jobseekerListing.category')}
            </p>
            <div className='categoryParamsBox'>
              <Select
                isClearable
                value={i.category}
                name={`category_${index}`}
                placeholder={t('jobseekerListing.selectCategory')}
                noOptionsMessage={() => t('jobseekerListing.noOptionsFound')}
                options={categories.map(i => ({ value: i.id, label: i.name }))}
                onChange={selectedOption => {
                  handleChangeRegionsCategoriesLanguages('searchCategories', 'category', selectedOption, index);
                  getSubCategoriesOptions(i.category?.value, index);
                }}
              />
            </div>
            {
              i.category && (
                <div>
                  <p>
                    {t('jobseekerListing.subCategory')}
                  </p>
                  <div className='categoryParamsBox'>
                    <Select
                      isMulti
                      value={i.sub_categories}
                      name={`sub_category_${index}`}
                      options={subCategories[index]?.map(i => (i))}
                      placeholder={t('jobseekerListing.selectSubCategory')}
                      noOptionsMessage={() => t('jobseekerListing.noOptionsFound')}
                      onChange={selectedOptions => handleChangeRegionsCategoriesLanguages('searchCategories', 'sub_categories', selectedOptions, index, 5)}
                      styles={{
                        multiValue: baseStyles => ({
                          ...baseStyles,
                          width: '100%',
                          justifyContent: 'space-between',
                        }),
                      }}
                    />
                    {
                      errors.searchCategories[index]?.sub_categories && (
                        <div className='text-danger'>{errors.searchCategories[index]?.sub_categories}</div>
                      )
                    }
                  </div>
                </div>
              )
            }
            <div className='advancedSearchButtons'>
              <button
                type='button'
                onClick={() => handleAddSearchItem('searchCategories')}
                disabled={i.category == null || searchCategories?.length > 2}
              >
                <i className='fa-solid fa-plus' />
                {t('jobseekerListing.addCategory')}
              </button>
              {
                searchCategories?.length > 1 && (
                  <button
                    type='button'
                    onClick={() => handleRemoveSearchParam('searchCategories', index)}
                  >
                    <i className='fa-solid fa-trash' />
                    {t('jobseekerListing.remove')}
                  </button>
                )
              }
            </div>
          </div>
        ))
      }
      <h2>
        {t('jobseekerListing.salary')}
      </h2>
      <div className='paramsBox row'>
        <div className='col-4'>
          <p>
            {t('jobseekerListing.salaryFrom')}
          </p>
          <div className='searchSalaryBox'>
            <input
              type='text'
              name='searchSalaryFrom'
              value={searchSalaryFrom}
              onKeyDown={handleKeyDown}
              onChange={handleChangeAgeAndSalary}
              placeholder={t('jobseekerListing.salaryFrom')}
            />
          </div>
        </div>
        <div className='col-4'>
          <p>
            {t('jobseekerListing.salaryTo')}
          </p>
          <div className='searchSalaryBox'>
            <input
              type='text'
              name='searchSalaryTo'
              value={searchSalaryTo}
              onKeyDown={handleKeyDown}
              onChange={handleChangeAgeAndSalary}
              placeholder={t('jobseekerListing.salaryTo')}
            />
          </div>
        </div>
        <div className='col-4'>
          <p>
            {t('jobseekerListing.salaryCurrency')}
          </p>
          <div className='searchSalaryBox'>
            <select
              type='text'
              name='searchSalaryCurrency'
              value={searchSalaryCurrency}
              onChange={handleChangeAgeAndSalary}
              placeholder={t('jobseekerListing.salaryCurrency')}
            >
              <option value=''>{t('jobseekerListing.salaryCurrency')}</option>
              {
                Object.entries(currencies).map(([key, value]) => (
                  <option key={key} value={key}>
                    {value}
                  </option>
                ))
              }
            </select>
          </div>
        </div>
      </div>
      <h2>
        {t('jobseekerListing.experience')}
      </h2>
      <div className='paramsBox'>
        <div className='searchExperienceBox'>
          {
            searchExperienceCheckboxSettings.map(i => (
              <label key={i.name} className='checkboxLabel'>
                <input
                  name={i.name}
                  type='checkbox'
                  checked={searchExperience.includes(i.name)}
                  onChange={e => handleChangeExperienceWorkTypeGender(e, 'searchExperience')}
                />
                {t(`jobseekerListing.${i.text}`)}
              </label>
            ))
          }
        </div>
      </div>
      <h2>
        {t('jobseekerListing.industry')}
      </h2>
      <div className='paramsBox'>
        <div className='industryParamsBox'>
          <Select
            isMulti
            name='industry'
            value={searchIndustry}
            placeholder={t('jobseekerListing.selectIndustry')}
            noOptionsMessage={() => t('jobseekerListing.noOptionsFound')}
            options={industries.map(i => ({ value: i.id, label: i.name }))}
            onChange={selectedOption => handleChangeIndustryEducationDriverCategories('searchIndustry', selectedOption, 5)}
            styles={{
              multiValue: baseStyles => ({
                ...baseStyles,
                width: '100%',
                justifyContent: 'space-between',
              }),
            }}
          />
          {
            errors.searchIndustry && (
              <div className='text-danger'>{errors.searchIndustry}</div>
            )
          }
        </div>
      </div>
      <h2>
        {t('jobseekerListing.workType')}
      </h2>
      <div className='paramsBox'>
        <div className='searchWorkTypeBox'>
          {
            searchWorkTypeCheckboxSettings.map(i => (
              <label key={i.name} className='checkboxLabel'>
                <input
                  name={i.name}
                  type='checkbox'
                  checked={searchWorkType.includes(i.name)}
                  onChange={e => handleChangeExperienceWorkTypeGender(e, 'searchWorkType')}
                />
                {t(`jobseekerListing.${i.text}`)}
              </label>
            ))
          }
        </div>
      </div>
      <h2>
        {t('jobseekerListing.education')}
      </h2>
      <div className='paramsBox'>
        <div className='educationParamsBox'>
          <Select
            isMulti
            name='education'
            value={searchEducation}
            placeholder={t('jobseekerListing.selectEducation')}
            noOptionsMessage={() => t('jobseekerListing.noOptionsFound')}
            options={education_level.map(i => ({ value: i.value, label: i.name }))}
            onChange={selectedOption => handleChangeIndustryEducationDriverCategories('searchEducation', selectedOption)}
            styles={{
              multiValue: baseStyles => ({
                ...baseStyles,
                width: '100%',
                justifyContent: 'space-between',
              }),
            }}
          />
        </div>
      </div>
      <h2>
        {t('jobseekerListing.languages')}
      </h2>
      {
        searchLanguages?.map((i, index) => (
          <div key={index} className='paramsBox'>
            <p>
              {t('jobseekerListing.language')}
            </p>
            <div className='languageParamsBox'>
              <Select
                isClearable
                value={i.lng}
                name={`lng_${index}`}
                placeholder={t('jobseekerListing.selectLanguage')}
                noOptionsMessage={() => t('jobseekerListing.noOptionsFound')}
                options={langs.map(i => ({ value: i.id, label: i.name }))}
                onChange={selectedOption => handleChangeRegionsCategoriesLanguages('searchLanguages', 'lng', selectedOption, index)}
              />
            </div>
            {
              i.lng && (
                <div>
                  <p>
                    {t('jobseekerListing.lngSkill')}
                  </p>
                  <div className='languageParamsBox'>
                    <Select
                      isClearable
                      value={i.lng_skill}
                      name={`lng_skill_${index}`}
                      placeholder={t('jobseekerListing.selectLngSkill')}
                      noOptionsMessage={() => t('jobseekerListing.noOptionsFound')}
                      options={lang_skills.map(i => ({ value: i.id, label: i.name }))}
                      onChange={selectedOption => handleChangeRegionsCategoriesLanguages('searchLanguages', 'lng_skill', selectedOption, index)}
                    />
                  </div>
                </div>
              )
            }
            <div className='advancedSearchButtons'>
              <button
                type='button'
                onClick={() => handleAddSearchItem('searchLanguages')}
                disabled={i.lng === null || searchLanguages?.length > 2}
              >
                <i className='fa-solid fa-plus' />
                {t('jobseekerListing.addLanguage')}
              </button>
              {
                searchLanguages?.length > 1 && (
                  <button
                    type='button'
                    onClick={() => handleRemoveSearchParam('searchLanguages', index)}
                  >
                    <i className='fa-solid fa-trash' />
                    {t('jobseekerListing.remove')}
                  </button>
                )
              }
            </div>
          </div>
        ))
      }
      <h2>
        {t('jobseekerListing.age')}
      </h2>
      <div className='paramsBox row'>
        <div className='col-6'>
          <p>
            {t('jobseekerListing.ageFrom')}
          </p>
          <div className='searchAgeBox'>
            <input
              type='text'
              name='searchAgeFrom'
              value={searchAgeFrom}
              onKeyDown={handleKeyDown}
              onChange={handleChangeAgeAndSalary}
              placeholder={t('jobseekerListing.ageFrom')}
            />
          </div>
        </div>
        <div className='col-6'>
          <p>
            {t('jobseekerListing.ageTo')}
          </p>
          <div className='searchAgeBox'>
            <input
              type='text'
              name='searchAgeTo'
              value={searchAgeTo}
              onKeyDown={handleKeyDown}
              onChange={handleChangeAgeAndSalary}
              placeholder={t('jobseekerListing.ageTo')}
            />
          </div>
        </div>
      </div>
      <h2>
        {t('jobseekerListing.gender')}
      </h2>
      <div className='paramsBox'>
        <div className='searchGenderBox'>
          {
            searchGenderCheckboxSettings.map(i => (
              <label key={i.name} className='checkboxLabel'>
                <input
                  name={i.name}
                  type='checkbox'
                  checked={searchGender.includes(i.name)}
                  onChange={e => handleChangeExperienceWorkTypeGender(e, 'searchGender')}
                />
                {t(`jobseekerListing.${i.text}`)}
              </label>
            ))
          }
        </div>
      </div>
      <h2>
        {t('jobseekerListing.driverLicense')}
      </h2>
      <div className='searchDriverLicenseBox'>
        <label className='checkboxLabel'>
          <input
            type='checkbox'
            name='searchDriverLicense'
            checked={searchDriverLicense}
            onChange={handleChangeSearchDriverLicense}
          />
          {t('jobseekerListing.driverLicense')}
        </label>
      </div>
      {
        searchDriverLicense && (
          <div>
            <p>
              {t('jobseekerListing.driverCategories')}
            </p>
            <div className='searchDriverLicenseBox'>
              <Select
                isMulti
                name='searchDriverCategories'
                value={searchDriverCategories}
                placeholder={t('jobseekerListing.selectDriverCategory')}
                noOptionsMessage={() => t('jobseekerListing.noOptionsFound')}
                options={driver_categories.map(i => ({ value: i.id, label: i.name }))}
                onChange={selectedOption => handleChangeIndustryEducationDriverCategories('searchDriverCategories', selectedOption)}
              />
            </div>
          </div>
        )
      }
      <div className='advancedSearchButtons'>
        <button
          type='button'
          onClick={() => handleResetFilters()}
        >
          <i className='fa-solid fa-arrows-rotate' />
          {t('jobseekerListing.resetFilters')}
        </button>
      </div>
    </section>
  );
};

export default DesktopAdvancedSearch;
